import { Card as Base, Image } from "@cancer-council-queensland/react";
import { renderStoryblokComponents } from "..";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Card = _ref => {
  var {
    image,
    children,
    layout,
    direction
  } = _ref;
  return /*#__PURE__*/_jsxs(Base, {
    layout: layout,
    direction: direction,
    children: [image ? image.filename ? /*#__PURE__*/_jsx(Image, {
      image: image,
      aspect: "wide",
      width: "max"
    }) : renderStoryblokComponents(image) : null, /*#__PURE__*/_jsx(Base.Content, {
      children: renderStoryblokComponents(children)
    })]
  });
};
//# sourceMappingURL=card.js.map